export default {
      id: "color_ancestry_lilac-usage",
      viewBox: "0 0 49 70",
      url: __webpack_public_path__ + "sprite.svg#color_ancestry_lilac",
      toString: function () {
        return this.url;
      }
    }